

const createModel = () => {

	const data = {}
	const listeners = []

	const set = (key, val) => {
		data[key] = val
		updateListeners(key, val)
	}

	const updateListeners = (key, val) => {
		listeners.forEach(listener => {
			if (listener.key && listener.key === key) listener.callback(val)
			if (listener.key === undefined) listener.callback(key, val)
		})
	}

	const subscribe = (keyOrCallback, callback = undefined) => {
		if (typeof keyOrCallback === 'string' && typeof callback === 'function') 
			listeners.push({ key : keyOrCallback, callback })
		if (typeof keyOrCallback === 'function' && callback === undefined) 
			listeners.push({ key : undefined, callback : keyOrCallback })
	}

	return { 
		data : () => data, 
		set, 
		subscribe 
	}
}

const sort = (attr = 'data-filter-time', asc = true) => {
	return (a, b) => {
		if (a.getAttribute(attr) === b.getAttribute(attr)) return 0
		const order = (a.getAttribute(attr) > b.getAttribute(attr)) ? 1 : -1
		return asc ? order : -order;
	}
}

const show = (items, { time, location, type }, parent, noResultsEl, fragment) => {

	const currentDate = new Date().toISOString()

	const sortMap = {
		'all' : sort(false),
		'past' : sort(false),
		'future' : sort(true),
	}
	
	items.sort(sortMap[time] || sort());

	items.map(item => {
		const date = item.getAttribute('data-filter-time')
		const itemLocation = item.getAttribute('data-filter-location')
		const itemType = item.getAttribute('data-filter-type')
		const past = (currentDate > date)
		const future = (currentDate <= date)

		const locationMatch = 
			// match all
			!location || 
			// match specific
			(location.trim().toLowerCase() === itemLocation.trim().toLowerCase())

		const timeMatch = 
			(time === 'all') || 
			(time === 'past' && past) ||
			(time === 'future' && future)

		const typeMatch = 
			// match all
			!type ||
			// match specific
			(type.trim().toLowerCase() === itemType.trim().toLowerCase())

		const matched = (timeMatch && locationMatch && typeMatch)

		// add each child in order (sorts visually)
		// put non-matching els into a document fragment
		;(matched ? parent : fragment).appendChild(item)
	})

	const results = parent.children.length
	noResultsEl.innerHTML = results ? '' : status(results, { time, location, type })
}

const status = (count, { time, location, type }) => {

	const eventString = count === 1 ? 'event' : 'events'
	const timeType = (() => {
		if (time === 'future') return 'upcoming'
		if (time === 'past') return 'past'
		if (time === 'all') return ""
	})()

	const eventType = type.toLowerCase()
	const locationString = location && `in <span class="text-highlight">${location}</span>` || ''

	if (!count) return `<p>No ${timeType} ${eventType} events found ${locationString}</p>`

	return `
		<p>Showing ${count > 1 && !timeType && 'all' || ''} <strong>${count}</strong> ${timeType} ${eventType} ${eventString} ${locationString}</p>
	`
}

export default () => {

	const list = document.querySelector('.js-events-filter-list')
	const items = [...document.querySelectorAll('.js-events-filter-item')]
	const locationSelect = document.querySelector('[data-events-filter-set-location]')
	const typeSelect = document.querySelector('[data-events-filter-set-type]')
	const timeButtons = [...document.querySelectorAll('[data-events-filter-set-time]')]
	const noResultsEl = document.querySelector('[data-events-no-results]')
	const frag = document.createDocumentFragment()

	if (!list || !items.length || !locationSelect || !timeButtons.length) return
	
	// model
	const model = createModel()

	// on change

	model.subscribe('time', function(newTime) {
		timeButtons.forEach(button => button.classList.remove('active'))
		const current = timeButtons.filter(button => button.getAttribute('data-events-filter-set-time') === newTime).shift()
		current && current.classList.add('active')
		show(items, model.data(), list, noResultsEl, frag)
	})

	model.subscribe('location', val => {
		locationSelect.value = val
		show(items, model.data(), list, noResultsEl,frag)
	})

	model.subscribe('type', val => {
		typeSelect.value = val
		show(items, model.data(), list, noResultsEl, frag)
	})

	// event handlers

	timeButtons.map(button => {
		button.addEventListener('click', e => {
			model.set('time', e.currentTarget.getAttribute('data-events-filter-set-time'))
		})
	})

	locationSelect.addEventListener('change', e => {
		model.set('location', e.currentTarget.value)
	})

	typeSelect.addEventListener('change', e => {
		model.set('type', e.currentTarget.value)
	})

	// init

	function setFromDOM() {
		// time
		const button = timeButtons.filter(button => button.classList.contains('active'))
		button.length && model.set('time', button[0].getAttribute('data-events-filter-set-time'))
		// location
		locationSelect && model.set('location', locationSelect.value)
		// type
		typeSelect && model.set('type', typeSelect.value)
	}
	setFromDOM()
}